import React, { useEffect, useRef, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Textarea } from '@sololearnorg/sol';
import classNames from 'classnames';
import { ClickType, aIChatPlaygroundContext } from '../../aIChatPlaygroundConstants';
import s from './AIChatPlaygroundMessageInput.scss';
import { AIChatPlaygroundService } from '../../services/AIChatPlaygroundService';
import { Container, i18n } from '../../../../symphony';
import { TopArrow } from '../../../../shared/public/assets/icons/TopArrow';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { AIChatPlaygroundReset } from '../Reset/AIChatPlaygroundReset';
import { InputState } from '../../aIChatPlaygroundInterface';
import { AIChatPlaygrountTrackingService } from '../../services/AIChatPlaygrountTrackingService';

export const AIChatPlaygroundMessageInput = () => {
	useStyles(s);
	const trackingService = Container.take(aIChatPlaygroundContext.value, AIChatPlaygrountTrackingService);
	const textareaRef = useRef<HTMLTextAreaElement>(null);
	const formRef = useRef<HTMLFormElement>(null);
	const { newMessageHandler } = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundService);
	const { isResponseLoading, configs, isInitialState } = useContainerData(
		aIChatPlaygroundContext.value,
		AIChatPlaygroundStore,
		['isResponseLoading', 'configs', 'isInitialState'],
	);
	const [message, setMessage] = useState(isInitialState ? configs.inputDefaultValue || '' : '');

	const onMessageSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
		e?.preventDefault();
		if (message === '') {
			return;
		}

		newMessageHandler(message);
		setMessage('');
	};

	const inputKeyDownHandler = (e: KeyboardEvent) => {
		if (!e.shiftKey && e.key === 'Enter') {
			e.stopPropagation();
			onMessageSubmit(e as any);
		}
	};

	useEffect(() => {
		if (isInitialState && textareaRef.current) {
			setMessage(configs.inputDefaultValue || '');
		}
	}, [isInitialState, textareaRef.current]);

	useEffect(() => {
		if (!textareaRef.current) return;

		textareaRef.current.style.height = '48px';
		if (message === '') return;

		textareaRef.current.style.height = `${Math.min(
			textareaRef.current.scrollHeight + 2,
			156,
		)}px`;
	}, [message]);

	if (configs.inputState === InputState.Hidden) {
		return <AIChatPlaygroundReset noInput />;
	}

	return (
		<div className="ai-chat-playground-message-input__container">
			<AIChatPlaygroundReset />
			<form
				className="ai-chat-playground-message-input"
				onKeyPress={(e) => { e.stopPropagation(); }}
				onSubmit={onMessageSubmit}
				ref={formRef}
			>
				<Textarea
					ref={textareaRef}
					className="ai-chat-playground-message-input__input"
					value={message}
					placeholder={i18n.t('ai-chat.input.placeholder')}
					onChange={(e) => { setMessage(e.target.value); }}
					onKeyDown={inputKeyDownHandler}
					onClick={() => { trackingService.trackPlaygroundClick(ClickType.FreeTextboxInput); }}
				/>
				<div
					className={
						classNames(
							'ai-chat-playground-message-input__send-icon',
							message.length > 0 && !isResponseLoading && 'active',
						)
					}
					onClick={() => { onMessageSubmit(); }}
				>
					<TopArrow />
				</div>
			</form>
		</div>
	);
};
